import * as React from 'react'
import {Link} from "gatsby"

const Overlay = () => {
    return (
        <div>
            <div className="pop-up-media">
                <figure>
                    <img alt="" className="ort-img" src={"/images/Nuernberg/teaser-nuernberg.jpg"}/>
                    <figcaption>
                        Quelle: Stadtarchiv Nürnberg
                    </figcaption>
                </figure>
            </div>
            <div className="pop-up-body">
                <p className='ort-header'>
                    1919: Nürnberg – Saalbau des Industrie- und Kulturvereins </p>
                <p className="ort-subheader">
                    <i>„Die Macht der Arbeiter liegt in ihrer Organisation.“</i>
                </p>
                <Link to="/orte/nuernberg/" className='ort-text icon-arrow-right load-infobox'>
                    Mehr erfahren
                </Link>
            </div>

        </div>
    )
}

export default Overlay

